import ActionHeartSvg from '@nomadhealth/ui/src/icons/svgs/action-heart.svg';
import ActionPaperAirplaneSvg from '@nomadhealth/ui/src/icons/svgs/action-paper-airplane.svg';
import DescriptiveCalendarSvg from '@nomadhealth/ui/src/icons/svgs/descriptive-calendar.svg';
import DescriptiveClockSvg from '@nomadhealth/ui/src/icons/svgs/descriptive-clock.svg';
import DescriptiveCoffeeSvg from '@nomadhealth/ui/src/icons/svgs/descriptive-coffee.svg';
import DescriptiveLocationPin from '@nomadhealth/ui/src/icons/svgs/descriptive-location-pin.svg';
import Feature1stToApplySvg from '@nomadhealth/ui/src/icons/svgs/feature-1st-to-apply.svg';
import Feature1stToApplyFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-1st-to-apply-filled.svg';
import FeatureAutoOfferSvg from '@nomadhealth/ui/src/icons/svgs/feature-auto-offer.svg';
import FeatureAutoOfferFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-auto-offer-filled.svg';
import FeatureEasyApplySvg from '@nomadhealth/ui/src/icons/svgs/feature-easy-apply.svg';
import FeatureEasyApplyFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-easy-apply-filled.svg';
import FeatureExclusiveSvg from '@nomadhealth/ui/src/icons/svgs/feature-exclusive.svg';
import FeatureExclusiveFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-exclusive-filled.svg';
import FeatureNearbySvg from '@nomadhealth/ui/src/icons/svgs/feature-nearby.svg';
import FeatureNearbyFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-nearby-filled.svg';
import FeatureNewItemSvg from '@nomadhealth/ui/src/icons/svgs/feature-new-item.svg';
import FeatureNewItemFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-new-item-filled.svg';
import FeatureOneClickSvg from '@nomadhealth/ui/src/icons/svgs/feature-one-click.svg';
import FeatureOneClickFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-one-click-filled.svg';
import FeaturePayRateSvg from '@nomadhealth/ui/src/icons/svgs/feature-pay-rate.svg';
import FeaturePayRateFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-pay-rate-filled.svg';
import FeatureSocialProofSvg from '@nomadhealth/ui/src/icons/svgs/feature-social-proof.svg';
import FeatureSocialProofFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-social-proof-filled.svg';
import FeatureTopHospitalSvg from '@nomadhealth/ui/src/icons/svgs/feature-top-hospital.svg';
import FeatureTopHospitalFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-top-hospital-filled.svg';
import FeatureTopMatchSvg from '@nomadhealth/ui/src/icons/svgs/feature-top-match.svg';
import FeatureTopMatchFilledSvg from '@nomadhealth/ui/src/icons/svgs/feature-top-match-filled.svg';
import StatusSuccessFilledSvg from '@nomadhealth/ui/src/icons/svgs/status-checkmark-filled.svg';

import BaseIcon, { IconProps } from '@/components/icons/base-icon';

//! Please, add in alphabetical order

export const IconActionHeart = (props: IconProps) => (
  <BaseIcon Icon={ActionHeartSvg} {...props} />
);

export const IconActionSendMessage = (props: IconProps) => (
  <BaseIcon Icon={ActionPaperAirplaneSvg} {...props} />
);

export const IconDescriptiveCalendar = (props: IconProps) => (
  <BaseIcon Icon={DescriptiveCalendarSvg} {...props} />
);

export const IconDescriptiveClock = (props: IconProps) => (
  <BaseIcon Icon={DescriptiveClockSvg} {...props} />
);

export const IconDescriptiveCoffee = (props: IconProps) => (
  <BaseIcon Icon={DescriptiveCoffeeSvg} {...props} />
);

export const IconDescriptiveLocationPin = (props: IconProps) => (
  <BaseIcon Icon={DescriptiveLocationPin} {...props} />
);

export const IconFeatureAutoOffer = (props: IconProps) => (
  <BaseIcon Icon={FeatureAutoOfferSvg} {...props} />
);

export const IconFeatureAutoOfferFilled = (props: IconProps) => (
  <BaseIcon Icon={FeatureAutoOfferFilledSvg} {...props} />
);

export const IconFeature1stToApply = (props: IconProps) => (
  <BaseIcon Icon={Feature1stToApplySvg} {...props} />
);

export const IconFeature1stToApplyFilled = (props: IconProps) => (
  <BaseIcon Icon={Feature1stToApplyFilledSvg} {...props} />
);

export const IconFeatureEasyApply = (props: IconProps) => (
  <BaseIcon Icon={FeatureEasyApplySvg} {...props} />
);

export const IconFeatureEasyApplyFilled = (props: IconProps) => (
  <BaseIcon Icon={FeatureEasyApplyFilledSvg} {...props} />
);

export const IconFeatureExclusive = (props: IconProps) => (
  <BaseIcon Icon={FeatureExclusiveSvg} {...props} />
);

export const IconFeatureExclusiveFilled = (props: IconProps) => (
  <BaseIcon Icon={FeatureExclusiveFilledSvg} {...props} />
);

export const IconFeatureNearby = (props: IconProps) => (
  <BaseIcon Icon={FeatureNearbySvg} {...props} />
);

export const IconFeatureNearbyFilled = (props: IconProps) => (
  <BaseIcon Icon={FeatureNearbyFilledSvg} {...props} />
);

export const IconFeatureNewItem = (props: IconProps) => (
  <BaseIcon Icon={FeatureNewItemSvg} {...props} />
);

export const IconFeatureNewItemFilled = (props: IconProps) => (
  <BaseIcon Icon={FeatureNewItemFilledSvg} {...props} />
);

export const IconFeatureOneClick = (props: IconProps) => (
  <BaseIcon Icon={FeatureOneClickSvg} {...props} />
);

export const IconFeatureOneClickFilled = (props: IconProps) => (
  <BaseIcon Icon={FeatureOneClickFilledSvg} {...props} />
);

export const IconFeaturePayRate = (props: IconProps) => (
  <BaseIcon Icon={FeaturePayRateSvg} {...props} />
);

export const IconFeaturePayRateFilled = (props: IconProps) => (
  <BaseIcon Icon={FeaturePayRateFilledSvg} {...props} />
);

export const IconFeatureSocialProof = (props: IconProps) => (
  <BaseIcon Icon={FeatureSocialProofSvg} {...props} />
);

export const IconFeatureSocialProofFilled = (props: IconProps) => (
  <BaseIcon Icon={FeatureSocialProofFilledSvg} {...props} />
);

export const IconFeatureTopHospital = (props: IconProps) => (
  <BaseIcon Icon={FeatureTopHospitalSvg} {...props} />
);

export const IconFeatureTopHospitalFilled = (props: IconProps) => (
  <BaseIcon Icon={FeatureTopHospitalFilledSvg} {...props} />
);

export const IconFeatureTopMatch = (props: IconProps) => (
  <BaseIcon Icon={FeatureTopMatchSvg} {...props} />
);

export const IconFeatureTopMatchFilled = (props: IconProps) => (
  <BaseIcon Icon={FeatureTopMatchFilledSvg} {...props} />
);

export const IconStatusSuccess = (props: IconProps) => (
  <BaseIcon Icon={StatusSuccessFilledSvg} {...props} />
);
